import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/global.css';
import '../styles/Landing.css';

const ContactUs = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const mailto = `mailto:support@mylinx.in?subject=${encodeURIComponent(form.subject || 'Contact from mylinx.in')}&body=${encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`)}`;
    window.location.href = mailto;
    setSent(true);
  };

  return (
    <div className="landing-bg" style={{ minHeight: '100vh' }}>
      <div className="landing-orbs">
        <div className="orb1" /><div className="orb2" /><div className="orb3" />
      </div>

      <nav className="navbar">
        <Link to="/" style={{ textDecoration: 'none' }}><div className="logo">my<em>linx</em></div></Link>
        <div className="nav-links">
          <Link to="/login" className="nav-a">Login</Link>
          <Link to="/register" className="btn-main" style={{ padding: '10px 22px', fontSize: 12 }}>Get Started ↗</Link>
        </div>
      </nav>

      <div style={{ maxWidth: 640, margin: '0 auto', padding: '80px 24px 60px' }}>
        <div className="tag" style={{ marginBottom: 20, display: 'inline-flex' }}>Contact Us</div>
        <h1 style={{ fontSize: 42, fontWeight: 800, marginBottom: 12, lineHeight: 1.2 }}>
          We're here to <em>help.</em>
        </h1>
        <p style={{ color: 'var(--muted)', fontSize: 16, lineHeight: 1.8, marginBottom: 48 }}>
          Got a question or issue? We personally respond to every email — usually within a few hours.
        </p>

        {/* Contact options */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 48 }}>
          {[
            { icon: '📧', title: 'Email Support', desc: 'For questions, issues, billing', link: 'mailto:support@mylinx.in', label: 'support@mylinx.in' },
            { icon: '🐛', title: 'Report a Bug', desc: 'Found something broken?', link: 'mailto:support@mylinx.in?subject=Bug Report', label: 'Report now' },
          ].map((item, i) => (
            <a key={i} href={item.link} style={{
              display: 'block', background: 'var(--link-bg)', border: '1px solid var(--border)',
              borderRadius: 12, padding: 20, textDecoration: 'none', color: 'inherit',
            }}>
              <div style={{ fontSize: 28, marginBottom: 10 }}>{item.icon}</div>
              <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>{item.title}</div>
              <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 10 }}>{item.desc}</div>
              <div style={{ fontSize: 12, color: 'var(--accent)', fontWeight: 600 }}>{item.label} →</div>
            </a>
          ))}
        </div>

        {/* Contact form */}
        <div style={{ background: 'var(--link-bg)', border: '1px solid var(--border)', borderRadius: 16, padding: 28 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 20 }}>Send us a message</div>
          {sent ? (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
              <div style={{ fontSize: 15, fontWeight: 600 }}>Your email client has opened!</div>
              <div style={{ fontSize: 13, color: 'var(--muted)', marginTop: 6 }}>
                Send the email to complete your message.
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                <div>
                  <label style={{ fontSize: 12, color: 'var(--muted)', display: 'block', marginBottom: 6 }}>Your Name</label>
                  <input type="text" required placeholder="Vikas Tomar"
                    value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
                    style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'transparent', color: 'inherit', fontSize: 13, outline: 'none', boxSizing: 'border-box' }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: 12, color: 'var(--muted)', display: 'block', marginBottom: 6 }}>Email Address</label>
                  <input type="email" required placeholder="you@example.com"
                    value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
                    style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'transparent', color: 'inherit', fontSize: 13, outline: 'none', boxSizing: 'border-box' }}
                  />
                </div>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 12, color: 'var(--muted)', display: 'block', marginBottom: 6 }}>Subject</label>
                <input type="text" placeholder="What's this about?"
                  value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })}
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'transparent', color: 'inherit', fontSize: 13, outline: 'none', boxSizing: 'border-box' }}
                />
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontSize: 12, color: 'var(--muted)', display: 'block', marginBottom: 6 }}>Message</label>
                <textarea required rows={5} placeholder="Tell us what's on your mind..."
                  value={form.message} onChange={e => setForm({ ...form, message: e.target.value })}
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'transparent', color: 'inherit', fontSize: 13, outline: 'none', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit' }}
                />
              </div>
              <button type="submit" className="btn-main" style={{ width: '100%', padding: '12px', fontSize: 14 }}>
                Send Message →
              </button>
            </form>
          )}
        </div>
      </div>

      <footer className="footer">
        <Link to="/" style={{ textDecoration: 'none' }}><div className="logo">my<em>linx</em></div></Link>
        <div className="footer-copy">MADE WITH OBSESSION © 2026</div>
        <div className="footer-links">
          <Link to="/about" className="footer-a">About</Link>
          <Link to="/contact" className="footer-a">Contact</Link>
          <Link to="/terms" className="footer-a">Terms</Link>
          <Link to="/privacy" className="footer-a">Privacy</Link>
          <Link to="/refund" className="footer-a">Refund</Link>
        </div>
      </footer>
    </div>
  );
};

export default ContactUs;